export default {
  setChoosingFieldId (state: {[key:string]: string}, value: string) {
    state.id = value
  },

  setClickFlag (state: {[key:string]: boolean}, flag: boolean) {
    state.clickFlag = flag
  },

  setClickModalFlag (state: {[key:string]: boolean}, flag: boolean) {
    state.clickModalFlag = flag
  },

  setChoosingFieldData (state: {[key:string]: any}, value: any) {
    state.fieldData.fieldId = value.fieldId
    state.fieldData.fieldName = value.fieldName
  },

  setChoosingModalFieldId (state: {[key:string]: string}, value: string) {
    state.modalId = value
  },

  setModalPlantingId (state: any, value: string) {
    state.modalPlantingId = value
  },

  setIsScroll (state: {[key:string]: boolean}, flag: boolean) {
    state.isScroll = flag
  }
}
